import { useState } from "react";
import { HERO_BG } from "@/mocks/kanliao";

const QUICK_TAGS = ["顶流", "直播一哥", "选秀咖", "合同纠纷", "恶意剪辑", "年度盘点", "塌房复盘", "同款"];

export default function Hero() {
  const [kw, setKw] = useState("");

  return (
    <section id="search" className="relative flex min-h-[92vh] w-full flex-col items-center justify-center overflow-hidden">
      <img
        src={HERO_BG}
        alt="看料站黑料关键词检索主视觉背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-background-950/90" />

      <div className="relative z-10 w-full px-4 md:px-6 pt-28 pb-20">
        <div className="mx-auto flex w-full max-w-4xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/20 bg-foreground-950/40 px-4 py-1.5 text-xs font-medium text-accent-200 backdrop-blur">
            <i className="ri-fire-line" />
            黑料关键词检索 · 目录清晰 · 标签精准
          </span>

          <h1 className="mt-6 font-heading text-4xl leading-tight font-black text-foreground-50 md:text-6xl">
            看料站 · 关键词定向找瓜
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-100/90 md:text-lg">
            支持按<strong className="text-accent-300">人物</strong>、<strong className="text-accent-300">事件</strong>、<strong className="text-accent-300">时间</strong>等标签快速查找目标内容。
            输入一个关键词，黑料目录与相关瓜点即刻呈现，定向搜索不迷路。
          </p>

          <form
            onSubmit={(e) => e.preventDefault()}
            className="mt-9 flex w-full max-w-2xl flex-col gap-2 sm:flex-row"
          >
            <label className="relative flex-1">
              <i className="ri-search-2-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-400" />
              <input
                type="text"
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="输入 人物 / 事件 / 标签关键词…"
                className="w-full rounded-md border-0 bg-foreground-50 py-3.5 pl-11 pr-4 text-sm text-foreground-950 outline-none ring-1 ring-transparent transition placeholder:text-foreground-400 focus:ring-2 focus:ring-accent-400"
              />
            </label>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-bold text-background-50 hover:bg-primary-600 transition-colors"
            >
              开始检索
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            <span className="whitespace-nowrap text-xs text-foreground-200/80">大家都在搜：</span>
            {QUICK_TAGS.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setKw(t)}
                className="whitespace-nowrap rounded-full border border-background-50/20 bg-foreground-950/40 px-3 py-1 text-xs text-foreground-100 backdrop-blur transition hover:border-accent-400 hover:text-accent-200"
              >
                {t}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="pointer-events-none absolute bottom-8 left-1/2 z-10 -translate-x-1/2 text-foreground-100/70">
        <i className="ri-arrow-down-line animate-bounce text-xl" />
      </div>
    </section>
  );
}